export enum MenuType {
  Default = 0,
  HelpUkraine = 1,
  WorldCleanupDay = 2,
  BackBase = 3,
}
